import { useEffect, useRef } from 'react';

function useClickOutside(ref, handler) {
  const handlerRef = useRef(handler);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        ref.current &&
        !ref.current.contains(e.target) &&
        document.body.contains(e.target)
      ) {
        handlerRef.current(e);
      }
    }

    document.addEventListener('mouseup', handleClickOutside);
    document.addEventListener('touchend', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  });
}

export default useClickOutside;
